import { FormattedNumber } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import React from 'react';
import { PromoContainer, OptimumPromo, EarnTag, PromoNumber } from './styles';

const inlineTypeStyles = `
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  margin-bottom: 0.5rem;
`;

const PROMO_STYLE = {
  carrier: inlineTypeStyles,
};

interface PromoProps {
  bestValueOffer: number;
  type?: string;
  isComparisonPage?: boolean;
  isDetailPage?: boolean;
  earnText?: string;
  asterisk?: boolean;
}

const Promo = ({
  bestValueOffer,
  type,
  isComparisonPage,
  isDetailPage,
  earnText,
  asterisk,
}: PromoProps) => (
  <PromoContainer
    customStyles={PROMO_STYLE[type]}
    isComparisonPage={isComparisonPage}
    className="PhoneListTarget"
  >
    {/* Earn text on comparison page is different from phones page */}
    {isComparisonPage && <EarnTag>{ReactHtmlParser(earnText)}</EarnTag>}
    {bestValueOffer ? (
      <OptimumPromo type={type}>
        {/* If not on details or compare page add "earn up to" */}
        {isDetailPage || isComparisonPage || (
        <span>{ReactHtmlParser(earnText)}</span>
        )}
        <FormattedNumber value={bestValueOffer}>
          {(num) => (
            <PromoNumber isComparisonPage={isComparisonPage}>
              {num}
              {asterisk && <sup>*</sup>}
            </PromoNumber>
          )}
        </FormattedNumber>
      </OptimumPromo>
    ) : null}
  </PromoContainer>
);

export default Promo;
